"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AudioVideoDidStart = require("./AudioVideoDidStart");
Object.keys(_AudioVideoDidStart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioVideoDidStart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioVideoDidStart[key];
    }
  });
});
var _AudioVideoDidStartConnecting = require("./AudioVideoDidStartConnecting");
Object.keys(_AudioVideoDidStartConnecting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioVideoDidStartConnecting[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioVideoDidStartConnecting[key];
    }
  });
});
var _AudioVideoDidStop = require("./AudioVideoDidStop");
Object.keys(_AudioVideoDidStop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioVideoDidStop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioVideoDidStop[key];
    }
  });
});
var _RemoteVideoSourcesDidChange = require("./RemoteVideoSourcesDidChange");
Object.keys(_RemoteVideoSourcesDidChange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RemoteVideoSourcesDidChange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RemoteVideoSourcesDidChange[key];
    }
  });
});
var _VideoTileDidUpdate = require("./VideoTileDidUpdate");
Object.keys(_VideoTileDidUpdate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VideoTileDidUpdate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoTileDidUpdate[key];
    }
  });
});
var _VideoTileWasRemoved = require("./VideoTileWasRemoved");
Object.keys(_VideoTileWasRemoved).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VideoTileWasRemoved[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VideoTileWasRemoved[key];
    }
  });
});
var _createAudioVideoObserver = require("./createAudioVideoObserver");
Object.keys(_createAudioVideoObserver).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createAudioVideoObserver[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createAudioVideoObserver[key];
    }
  });
});
var _AudioIntensityScore = require("./AudioIntensityScore");
Object.keys(_AudioIntensityScore).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioIntensityScore[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioIntensityScore[key];
    }
  });
});